import { useEffect } from 'react'
import { BoxProps } from '../types'
import { AnimatePresence } from 'framer-motion'
import { StyledSubsetBox } from '../styled'
import IconLeft from '~/assets/images/left.png'

export const SubsetBox: React.FC<Exclude<BoxProps, 'root'>> = ({
  title,
  children,
  onBack = console.log,
  className,
  bodyClassName,
  icon = 'back',
  headerRight,
}) => {
  useEffect(() => {
    const siblings = document.getElementsByClassName('subset-box')

    if (siblings.length > 1) {
      ;[...siblings].slice(0, -1).forEach((element) => {
        element.classList.add('hide')
      })
    }
    return () => {
      ;[...siblings].slice(0, -1).forEach((el) => el.classList.remove('hide'))
    }
  }, [])
  return (
    <AnimatePresence>
      <StyledSubsetBox
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        icon={icon}
        className={className}
      >
        <div className="title">
          {icon && (
            <>
              <i
                className={`icon icon-${icon}`}
                aria-controls="back"
                onClick={onBack}
              ></i>
              <img src={IconLeft.src} width={0} height={0} />
            </>
          )}
          <span>{title}</span>
          {headerRight}
        </div>
        <div className={`content ${bodyClassName}`}>{children}</div>
      </StyledSubsetBox>
    </AnimatePresence>
  )
}
